import { render } from "./BandeauResultat.vue?vue&type=template&id=c95d4e26"
import script from "./BandeauResultat.vue?vue&type=script&lang=js"
export * from "./BandeauResultat.vue?vue&type=script&lang=js"

import "./BandeauResultat.vue?vue&type=style&index=0&id=c95d4e26&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__